import { useState, useCallback, useEffect } from 'react';
import { DATA } from '../../../game/data';
import { observer } from 'mobx-react-lite';
import { IMAGES } from '../../../game/data/images';
import { COLORS } from '../../../game/data/colors';
import { TripLine } from './TripLine';
import { CompetitionTrip } from './CompetitionTrip';

export const Routes: React.FC = observer(() => {
  return (
    <>
      {DATA.airplanes
        .filter((a) => a.status === 'flying')
        .map((airplane) => (
          <TripLine key={airplane.id} tripData={airplane.currentTrip!} />
        ))}
      {DATA.competitionAirplanes.map((trip) => (
        <CompetitionTrip key={trip.id} tripData={trip} />
      ))}
    </>
  );
});
